import React, { useEffect, useState } from "react";
import { safeLocalStorage } from "../utils/safeStorage";

const CONSENT_KEY = "cookie_consent";

// Google Consent Mode replays this once gtag.js has loaded, even though the
// default (see public/index.html) already denied ad/analytics storage.
const grantTracking = () => {
  if (window.gtag) {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });
  }
  if (window.fbq) {
    window.fbq("consent", "grant");
  }
};

export default function CookieConsentPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const stored = safeLocalStorage.getItem(CONSENT_KEY);
    if (stored === "granted") {
      grantTracking();
      return;
    }
    if (stored === "denied") return;

    const timer = setTimeout(() => setShow(true), 400);
    return () => clearTimeout(timer);
  }, []);

  const resolve = (value) => {
    safeLocalStorage.setItem(CONSENT_KEY, value);
    if (value === "granted") grantTracking();
    setShow(false);
    window.dispatchEvent(new Event("cookie-consent-resolved"));
  };

  if (!show) return null;

  return (
    <div className="notif-popup cookie-consent-popup">
      <div className="notif-popup-icon">
        <i className="fas fa-cookie-bite"></i>
      </div>
      <div className="notif-popup-body">
        <p className="notif-popup-title">We Use Cookies</p>
        <p className="notif-popup-text">
          We use cookies for analytics and ads to improve your experience. See our{" "}
          <a href="/Privacy-Policy">Privacy Policy</a>.
        </p>
      </div>
      <div className="notif-popup-actions">
        <button className="notif-popup-btn notif-popup-btn--ghost" onClick={() => resolve("denied")}>
          Decline
        </button>
        <button className="notif-popup-btn notif-popup-btn--primary" onClick={() => resolve("granted")}>
          Accept
        </button>
      </div>
    </div>
  );
}
